import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';
import { SalesService } from 'src/app/services/sales.service';
import { ToastService } from 'src/app/shared-new/services/toast.service';
import { SaleSettingModel } from '../../models/sales/sale-settings.model';
import { ViewerService } from '../../services/viewer.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
@Component({
  selector: 'sale-horse-xray-reports-popup',
  templateUrl: './sale-horse-xray-reports-popup.component.html',
  styleUrls: ['./sale-horse-xray-reports-popup.component.scss'],
})
export class SaleHorseXRayReportsPopupComponent
  extends BaseUnsubscribeComponent
  implements OnInit
{
  @Input() public data: any;
  public isLoader = false;

  public studyFiles: {
    fileName: string;
    thumbURL: string;
    type: string;
    studyStatusId: number;
    saleId: number;
    horseId: number;
    scopeForm: FormGroup;
    createdDate: string;
    createdByUser: {
      userId: number;
      name: string;
      userLogin: string;
      emailAddress: string;
      image: string;
    };
  }[] = [];
  private saleSetting: SaleSettingModel;
  constructor(
    public readonly modal: NgbActiveModal,
    private readonly salesService: SalesService,
    private readonly sanitizer: DomSanitizer,
    private readonly viewerService: ViewerService,
    private toastService: ToastService
  ) {
    super();
  }

  closePopup(): void {
    this.modal.close(JSON.stringify(this.data));
  }

  public ngOnInit(): void {
    this.isLoader = true;
    this.salesService
      .getSaleViewerSettings(this.data.saleId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((saleSetting) => {
        this.saleSetting = saleSetting;
      });
    this.salesService
      .getSaleHorseStudyFiles(this.data.saleId, this.data.horseId)
      .subscribe(
        (response) => {
          if (response) {
            response.forEach((studyFile) => {
              if (studyFile.thumbURL.toLowerCase().includes('pdf')) {
                let formGroup = null;
                if (this.isClientNameRequired(studyFile)) {
                  formGroup = new FormGroup({
                    clientName: new FormControl('', [Validators.required]),
                  });
                }

                this.studyFiles.push({
                  fileName: studyFile.thumbFileName,
                  thumbURL: studyFile.thumbURL,
                  type: 'pdf',
                  studyStatusId: studyFile.studyStatusId,
                  scopeForm: formGroup,
                  createdDate: studyFile.createdDate,
                  createdByUser: studyFile.createdByUser,
                  saleId: studyFile.saleId,
                  horseId: studyFile.horseId,
                });
              }
            });

            this.isLoader = false;
          }
        },
        (errorResponse: Error) => {
          const errorData = JSON.parse(JSON.stringify(errorResponse));
          if (errorData?.error) {
            if (errorData?.status === 401 || errorData?.status === 500) {
              this.toastService.error(errorData.error.message);
            }

            if (errorData?.status === 400) {
              let errorMessages = '';
              if (errorData.error instanceof Array) {
                errorData.error.forEach((value: { message: string }) => {
                  errorMessages += value.message + '<br>';
                });
              } else {
                errorMessages = errorData.error.message;
              }

              this.toastService.error(errorMessages);
            }
          }

          this.isLoader = false;
        }
      );
  }
  openPdf(studyFile: any, scopeForm?: FormGroup): void {
    const form = scopeForm?.value;
    const study: any = {
      saleId: studyFile.saleId,
      horseId: studyFile.horseId,
    };
    this.viewerService.openPdf(study, studyFile, form?.clientName);
  }
  public isClientNameRequired(studyFile: any): boolean {
    if (
      studyFile &&
      studyFile.studyStatusId === 4 &&
      this.saleSetting.pdfReports
    ) {
      return true;
    }
    return false;
  }
  public safeUrlLink(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
